import './index.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Settings from './pages/Settings';
import Subscriptions from './pages/Subscriptions';
import Payments from './pages/Payments';
import Categories from './pages/Categories';
import Reports    from './pages/Reports';
import Operations from './pages/Operations';
import Devices    from './pages/Devices';
import Moderation from './pages/Moderation';
import Analytics  from './pages/Analytics';
import Referrals  from './pages/Referrals';
import Heatmap    from './pages/Heatmap';
import Logs       from './pages/Logs';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  return (user && (user.role === 'admin' || user.isAdmin))
    ? <Layout>{children}</Layout>
    : <Navigate to="/login" replace />;
};

const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  return (user && (user.role === 'admin' || user.isAdmin))
    ? <Navigate to="/" replace />
    : children;
};

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
            <Route path="/settings"       element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/subscriptions" element={<ProtectedRoute><Subscriptions /></ProtectedRoute>} />
            <Route path="/payments"    element={<ProtectedRoute><Payments /></ProtectedRoute>} />
            <Route path="/categories" element={<ProtectedRoute><Categories /></ProtectedRoute>} />
            <Route path="/operations" element={<ProtectedRoute><Operations /></ProtectedRoute>} />
            <Route path="/devices"    element={<ProtectedRoute><Devices    /></ProtectedRoute>} />
            <Route path="/moderation" element={<ProtectedRoute><Moderation /></ProtectedRoute>} />
            <Route path="/analytics"  element={<ProtectedRoute><Analytics  /></ProtectedRoute>} />
            <Route path="/referrals"  element={<ProtectedRoute><Referrals  /></ProtectedRoute>} />
            <Route path="/heatmap"    element={<ProtectedRoute><Heatmap    /></ProtectedRoute>} />
            <Route path="/logs"       element={<ProtectedRoute><Logs       /></ProtectedRoute>} />
            <Route path="/reports"    element={<ProtectedRoute><Reports    /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}
